import "../../components/styles/legal.scss"

import Attribution from "./Attribution"
import Layout from "../layout"
import React from "react"
import ReactMarkdown from "react-markdown"
import Seo from "../seo"

export default function LegalLayout({
  description,
  heading,
  headingSmall,
  featureImg,
  source,
  title,
  withoutBack = false,
}) {
  return (
    <Layout>
      <Seo description={description} title={title} />
      <div className="container">
        <div className="legal with-top-padding">
          {!withoutBack && <a href="/legal">Back to policies</a>}
          <div className="legal-header">
            <h1>{heading || title}</h1>
            {featureImg && <img alt="legal paper" src={featureImg} />}
          </div>
          <h2 style={{ marginTop: "0" }}>{headingSmall}</h2>
          <ReactMarkdown className="markdown-body" children={source} />
          <div className="mt-2">
            <Attribution />
          </div>
        </div>
      </div>
    </Layout>
  )
}
